import React, { useState, useRef, useEffect } from 'react';
import Footer from './LandingPage/Footer'
import NavBar from '../Navigation/NavBar';
import WhatAppMobile from './LandingPage/WhatAppMobile';
import { Box, TextField, useMediaQuery } from '@mui/material';
import "rsuite/dist/rsuite.min.css";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { MuiOtpInput } from "mui-one-time-password-input";
import { Controller } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-slideshow-image/dist/styles.css'
import iit_foundation from "../../assets/IIT-JEE Foundation.png";
import iit_fresher from "../../assets/IIT-JEE Fresher.png";
import iit_repeater from "../../assets/IIT-JEE Repeater.png";
import Neet_foundation from "../../assets/NEET Foundation.png";
import Neet_fresher from "../../assets/NEET Fresher.png";
import Neet_repeaters from "../../assets/NEET Repeaters.png";
import acadamic from "../../assets/academic.png";
import board_exams from "../../assets/Board Exam.png";
import Counselling from "../../assets/Counselling.png";
import Daily_practice from '../../assets/Daily Practice.png'
import exams from '../../assets/exams.png'
import Lecture from '../../assets/Lecture.png'
import Library from '../../assets/Library.png'
import minor_test from '../../assets/Minor tests.png'
import study_modules from '../../assets/Study Modules.png'
import Group2111 from "../../assets/Group2111.png";

const sxStyle = {
  display: "flex",
  justifyContent: { xs: "center" },
  alignItems: "center",
};



function OnlineCoaching() {
  const [otpNew, setOtpNew] = useState("");
  const handleChangeOtpNew = (NewValue) => {
    setOtpNew(NewValue);
  };

  const [openOtpNew, setOpenOtpNew] = useState(false);

  const handleOpenotpNew = () => {
    setOpenOtpNew(true);
  };

  const handleCloseOtpNew = () => {
    setOpenOtpNew(false);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const [smsIdNew, setSmsIdNew] = useState(null);
  const [studentQueryFormData, setStudentQueryFormData] = useState(null);
  const schema = yup.object().shape({
    email: yup.string().email().required(),
    fullName: yup.string().required(),
    pincode: yup.string().required(),
    area: yup.string().required(),
    city: yup.string().required(),
    mobileNumber: yup.string().required(),
    subject: yup.string().required(),
    course: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      classMode: "1",
    },
  });

  const [selectedColor, setSelectedColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const onSubmitHandler = async (data) => {
    setOtpNew("");
    setLoading(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", { hour: "2-digit", hour12: false, }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(date);
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(date);
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("area", data.area);
    formData.append("fullName", data.fullName);
    formData.append("pincode", data.pincode);
    formData.append("course", data.course);
    formData.append("subject", data.subject);
    formData.append("classMode", data.classMode);
    formData.append("city", data.city);
    formData.append("mobile", data.mobileNumber);
    formData.append("token", CurrentDateTime);
    formData.append("smsType", "generalQuery");
    setStudentQueryFormData(formData);

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/notifySMS",
        formData,
        config
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        setLoading(false);
        setOpenOtpNew(true);
        setOpen(false);
        setSmsIdNew(response.data.data.smsID.toString());
        reset();
      } else {
        toast.warning(response.data.message ?? "Something Went Wrong");
        setLoading(false);
      }
    } catch (error) {
      toast.error(
        error?.response.data.message ?? "An error occurred. Please try again."
      );
      setLoading(false);
    }
  };

  useEffect(() => {

  }, []);

  const handleResendOtpNew = async (e) => {
    e.preventDefault();
    setLoading2(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      date
    );
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      hour12: false,
    }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
      date
    );
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
      date
    );
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const tempFormData = new FormData();
    tempFormData.append("smsId", smsIdNew);
    tempFormData.append("mobile", studentQueryFormData.get("mobile"));
    tempFormData.append("smsType", "generalQuery");
    tempFormData.append("token", CurrentDateTime);

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/resendOTP",
        tempFormData
      );

      if (response.data.success.toString() === "true") {
        toast.success(response.data.message);
        setSmsIdNew(response.data.data.smsID.toString());
        setLoading2(false);
      } else {
        toast.error(response.data.message);
        setLoading2(false);
      }
    } catch (error) { }
  };

  const handleSubmitOtpNew = async (e) => {
    e.preventDefault();
    setLoading(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      date
    );
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      hour12: false,
    }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
      date
    );
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
      date
    );
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const formData = new FormData();
    formData.append("email", studentQueryFormData.get("email"));
    formData.append("area", studentQueryFormData.get("area"));
    formData.append("fullName", studentQueryFormData.get("fullName"));
    formData.append("pincode", studentQueryFormData.get("pincode"));
    formData.append("course", studentQueryFormData.get("course"));
    formData.append("subject", studentQueryFormData.get("subject"));
    formData.append("classMode", studentQueryFormData.get("classMode"));
    formData.append("city", studentQueryFormData.get("city"));
    formData.append("mobile", studentQueryFormData.get("mobile"));
    formData.append("token", CurrentDateTime);
    formData.append("smsType", "generalQuery");
    formData.append("smsId", smsIdNew);
    formData.append("smsOtp", otpNew);
    setStudentQueryFormData(formData);

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/verifyOtp",
        formData
      );

      if (response.data.success.toString() === "true") {
        toast.success(response.data.message);
        setOpenOtpNew(false);
        setSmsIdNew(response.data.data.smsID.toString());
        setLoading(false);
        setOtpNew("");
      } else {
        toast.error(response.data.message ?? "OTP does not match.");
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data.message);
      setLoading(false);
    }
  };
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");

  const [activeTab, setActiveTab] = useState('');
  const tabContentRef = useRef(null);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  };

  const handleClickOutside = (event) => {
    if (tabContentRef.current && !tabContentRef.current.contains(event.target)) {
      setActiveTab(null);
    }
  };

  const tabItemStyle = {
    height: '140px',
    width: '190px',
    border: '1px solid black',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  };

  const tabContentStyle = {
    border: '1px solid black',
    width: isXs?  '50%':'80%',
    margin: '10px auto',
    padding: '20px 20px 20px 30px',
    borderRadius: '10px',
  };

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const divStyle = (index) => ({
    height: "130px",
    width: "360px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    paddingLeft:'20px',
    gap: "20px",
    backgroundColor: hoveredIndex === index ? "white" : "#FFF7F3",
    transition: "background-color 0.3s ease",
  });

  useEffect(() => {
    document.title = "Best Online Tuition Classes for IIT- JEE, NEET, CBSE, ICSE & IB Boards";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "We Provide Online Tuition Classes with Best Tutors For IIT- JEE, NEET, BITSAT, Olympiads & CBSE, ICSE, IB boards (All Subjects).");
  }, []);

  return (<>

    <WhatAppMobile />
    <NavBar />

    <div
      style={{
        backgroundColor: "#C68863",
        width: "100%",
        height: isXs ? "33.5rem" : '62rem',
        padding: "0px 3rem",
        display: "flex",
        flexDirection: "column",
        gap: isXs ? "4rem" : "2.7rem",
        position: "relative",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          fontFamily: "jost",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          gap: "1rem",
          marginTop: isXs ? '80px' : '30px'
        }}
      >
        <h1
          style={{
            textAlign: "center",
            marginTop: isXs ? '' : '1rem',
            fontSize: isXs ? "2.3rem" : "1.8rem",
            marginBottom: '1rem'
          }}
        >
          Online Tuition Classes with IITians & Expert Faculty
        </h1>

        <div style={{ fontSize: isXs ? '16px' : '18px', width: isXs ? '65%' : '80%', textAlign: 'center' }}>
          Achieve Excellence : One Student, One Teacher, Expert Online Coaching for IIT- JEE (Main & Adv), NEET-UG, BITSAT, Olympiads, 12th ,11th (CBSE ICSE IB & other state board) ,Our experienced teachers will guide you to achieve academic success.
        </div>
        <span>
          <button
            style={{
              padding: ".8rem 7rem",
              border: "none",
              boxShadow: "4px 8px 4px rgb(0, 0, 0, .1)",
              borderRadius: "5px",
              fontSize: "1.4rem",
              marginTop: isXs ? "4rem" : "2rem",
              fontWeight: "bold",
              backgroundColor: "#FFDB7E",
              color: "#866D2C",
              gap: "40rem",
              width: isXs ? '' : '22.4rem',
            }}
            onClick={handleOpen}
            type="button"
          >
           Book a Free Demo Class
          </button>
        </span>
        <h2 style={{ marginTop: isXs ? "30px" : '20px', fontSize: isXs ? '30px' : '25px', fontWeight: '700', textAlign: 'center' }}>One Student, One Teacher, Endless Possibilities</h2>

      </div>
      <div
        style={{
          display: isXs ? 'flex' : 'none',
          zIndex: "",
          justifyContent: isXs ? "space-between" : 'none',
          alignItems: "center",
          position: "absolute",
          top: isXs ? "30.7rem" : '30.2rem',
          left: isXs ? '' : '34px'
        }}
      >
   
      </div>
    </div>


    <ul
    ref={tabContentRef}
        className="nav nav-pills mb-3"
        id="pills-tab"
        role="tablist"
        style={{
          width: '100%',
          backgroundColor: '#F8E7C9',
          height: isXs ? '180px' : '1000px',
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          alignItems: 'center',
          flexDirection: isXs ? 'row' : 'column',
        }}
      >
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-home' ? 'active' : ''}
            onClick={() => handleTabClick('pills-home')}
            style={tabItemStyle}
          >
            <img height="70" src={iit_foundation} alt="IIT Foundation" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>IIT-JEE FOUNDATION</div>
          </div>
        </li>
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-profile' ? 'active' : ''}
            onClick={() => handleTabClick('pills-profile')}
            style={tabItemStyle}
          >
            <img height="70" src={iit_fresher} alt="IIT Fresher" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>IIT-JEE FRESHER</div>
          </div>
        </li>
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-contact' ? 'active' : ''}
            onClick={() => handleTabClick('pills-contact')}
            style={tabItemStyle}
          >
            <img height="70" src={iit_repeater} alt="IIT Repeater" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>IIT-JEE REPEATOR</div>
          </div>
        </li>
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-contact2' ? 'active' : ''}
            onClick={() => handleTabClick('pills-contact2')}
            style={tabItemStyle}
          >
            <img height="70" src={Neet_foundation} alt="NEET Foundation" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>NEET FOUNDATION</div>
          </div>
        </li>
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-contact3' ? 'active' : ''}
            onClick={() => handleTabClick('pills-contact3')}
            style={tabItemStyle}
          >
            <img height="70" src={Neet_fresher} alt="NEET Fresher" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>NEET-FRESHER</div>
          </div>
        </li>
        <li className="nav-item" role="presentation">
          <div
            className={activeTab === 'pills-contact4' ? 'active' : ''}
            onClick={() => handleTabClick('pills-contact4')}
            style={tabItemStyle}
          >
            <img height="70" src={Neet_repeaters} alt="NEET Repeater" className="img-responsive" />
            <div style={{ fontWeight: "500", fontSize: '16px' }}>NEET REPEATORS</div>
          </div>
        </li>
      </ul>

      <div className="tab-content" id="pills-tabContent">
        <ul
          className={`tab-pane ${activeTab === 'pills-home' ? 'show active' : 'fade'}`}
          id="pills-home"
          style={tabContentStyle}
        >
          <li>Students moving from class 8th to 9th – Target year for IIT-JEE exam 2030</li>
          <li>Students moving from class 9th to 10th – Target year for IIT-JEE exam 2029</li>
          <li>Personalized interactive learning</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent</li>
          <li>Expert faculty build strong fundamentals.</li>
          <li>Keeps students motivated and focused.</li>
        </ul>

        <ul
          className={`tab-pane ${activeTab === 'pills-profile' ? 'show active' : 'fade'}`}
          id="pills-profile"
          style={tabContentStyle}
        >
          <li>Students moving from class 10th to 11th – Target year for IIT-JEE exam 2028</li>
          <li>Students moving from class 11th to 12th – Target year for IIT-JEE exam 2027</li>
          <li>Comprehensive IIT-JEE prep with interactive classes, practice exercises, and mock tests.</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent.</li>
          <li>Expert personalized guidance.</li>
          <li>Keeps students motivated and focused.</li>
        </ul>

        <ul
          className={`tab-pane ${activeTab === 'pills-contact' ? 'show active' : 'fade'}`}
          id="pills-contact"
          style={tabContentStyle}
        >
          <li>Repeater Students– Target year for IIT-JEE exam 2027</li>
          <li>Expert IIT-JEE mentors provide personalized one-on-one online classes with targeted feedback.</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent.</li>
          <li>Targeted support for repeat exam takers to overcome weaknesses and succeed.</li>
          <li>Join our program and get a second chance to crack the IIT-JEE exam</li>
        </ul>

        <ul
          className={`tab-pane ${activeTab === 'pills-contact2' ? 'show active' : 'fade'}`}
          id="pills-contact2"
          style={tabContentStyle}
        >
          <li>Students moving from class 8th to 9th – Target year for NEET-UG exam 2030</li>
          <li>Students moving from class 9th to 10th – Target year for NEET-UG exam 2029</li>
          <li>Personalized interactive learning.</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent.</li>
          <li>Expert faculty build strong fundamentals.</li>
          <li>Keeps students motivated and focused.</li>
        </ul>

        <ul
          className={`tab-pane ${activeTab === 'pills-contact3' ? 'show active' : 'fade'}`}
          id="pills-contact3"
          style={tabContentStyle}
        >
          <li>Students moving from class 10th to 11th – Target year for NEET-UG exam 2028</li>
          <li>Students moving from class 11th to 12th – Target year for NEET-UG 2027</li>
          <li>Comprehensive NEET prep with interactive classes, practice exercises, and mock tests.</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent.</li>
          <li>Expert personalized guidance.</li>
          <li>Live sessions, forums, and progress tracking ensure NEET success.</li>
        </ul>

        <ul
          className={`tab-pane ${activeTab === 'pills-contact4' ? 'show active' : 'fade'}`}
          id="pills-contact4"
          style={tabContentStyle}
        >
          <li>Repeater Students– Target year for NEET-UG exam 2027.</li>
          <li>Expert NEET mentors provide personalized one-on-one online classes with targeted feedback.</li>
          <li>Schedule your demo now and get a scholarship up to 90 percent.</li>
          <li>Targeted support for repeat exam takers to overcome weaknesses and succeed.</li>
          <li>Join our program and get a second chance to crack the NEET-UG exam.</li>
        </ul>
      </div>



      <Grid container sx={sxStyle} style={{ marginTop: isXs ? "5%" : "10%" }}>
             <Grid item xs={10} sm={5} md={6} lg={6} xl={6} xxl={6}>
               <div
                 style={{
                   marginLeft: isXs ? "5%" : "",
                   textAlign: isXs ? "" : "center",
                 }}
               >
                 <h2 style={{ fontWeight: "bold" }}>
                 Best Online Tuition Classes  With IITains and Expert Teachers
                 </h2>
                 <div
                   style={{
                     color: "#CB8B65",
                     marginTop: "3%",
                     fontSize: isXs ? "1.5vw" : "4vw",
                   }}
                 >
Learning Anytime, Anywhere with Online Coaching Classes
</div>
                 <div
                   style={{
                     marginTop: isXs ? "1%" : "10%",
                     fontSize: isXs ? "1.1vw" : "2.5",
                     textAlign: "justify",
                   }}
                 >
                   <div style={{ fontSize: '15px' }}>Learn anytime, anywhere with Kanha Home Tuitions. We offer the best online coaching classes to help your child succeed in school and competitive exams. Our experienced tutors focus on personalized, one-on-one learning through online tuition classes to give your child complete attention and guidance.
At Kanha Home Tuitions, we believe that every child can achieve great results with the right support. That’s why we provide subject-wise online coaching for Maths, Physics, Chemistry, and Biology. Our online classes are designed to help students prepare for IIT-JEE, NEET, Olympiads, BITSAT, AIIMS, KVPY, and board exams like CBSE, ICSE, IB, and State Boards.
</div>
                   <div style={{ marginTop: '20px', fontSize: '15px', border: '1px solid rgb(10,10,10,0.3)', backgroundColor: '#FFE2AB', padding: '10px 20px', borderRadius: '10px' }}>
                   <h4 style={{fontSize:'18px', fontWeight:'500', padding:'3px 0px'}}>Our Services</h4>
                   <li>One Student, One Teacher - Complete focus on your child</li>
                   <li>Experienced Tutors and IITians as Mentors</li>
                   <li>Subject-wise Online Tuition Classes</li>
                   <li>Flexible Learning - Study from Home at Your Convenience</li>
                   <div style={{marginTop:'10px'}}>If you are looking for high-quality online classes, expert online coaching, or personalized online tuitions, Kanha Home Tuitions is the perfect choice. Start your child’s journey towards success today with the best online tuition classes.</div>
                  </div>
                 </div>
               </div>
             </Grid>
     
             <Grid
               item
               xs={10}
               sm={5}
               md={6}
               lg={6}
               xl={6}
               xxl={6}
               style={{ textAlign: "center" }}
             >
               <img
                 src={Group2111}
                 alt="group2111"
                 style={{
                   width: isXs ? "70%" : "95%",
                   marginTop: isXs ? "10%" : "15%",
                 }}
               />
             </Grid>
           </Grid>


    <div style={{ marginBottom: isXs ? '0px' : '10px', paddingBottom: '6rem' }}>

      <div style={{ padding: isXs ? '0px 70px' : '0px 30px', display: 'flex', flexDirection: 'column', gap: '12px', marginTop:'50px' }}>
        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Best Managed Coaching System for Online Classes</div>
        <div style={{ fontSize: '16px', textAlign: 'center' }}>Experience the most efficient and effective online coaching system, designed to provide a structured and organised learning experience for students of all levels. Our system offers expert-led online classes, personalised learning plans, and comprehensive study material to ensure academic success in IIT- JEE (Main & Adv),  NEET-UG,  BITSAT, Olympiads, 12th ,11th (CBSE  ICSE  IB & other state board).</div>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
      </div>

      <div style={{ padding: isXs ? '0px 70px' : '0px 30px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Our Courses</div>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>IIT-JEE (Main and Advanced)</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>NEET-UG</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Olympiad</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>BITSAT</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>NDA</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>11<sup>th</sup>, 12<sup>th</sup> (CBSE, ICSE, IB & Other state board) </li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>9<sup>th</sup>, 10<sup>th</sup> (Foundation)</li>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
      </div>

      <div style={{
        width: '100%',
        backgroundColor: '#FFF7F3',
        display: 'grid',
        justifyItems: 'center',
        alignItems: 'center',
        gridTemplateColumns: isXs ? 'repeat(3, 1fr)' : 'repeat(1, 1fr)',
        marginTop: '70px',
        padding: isXs ? '70px 50px' : "70px 20px",
        rowGap: '30px'
      }}>
        <div
          style={divStyle(0)}
          onMouseEnter={() => setHoveredIndex(0)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={acadamic} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Academics</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(1)}
          onMouseEnter={() => setHoveredIndex(1)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={study_modules} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Study Modules</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(2)}
          onMouseEnter={() => setHoveredIndex(2)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={exams} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Exams</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(3)}
          onMouseEnter={() => setHoveredIndex(3)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={Daily_practice} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Daily Practice</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(4)}
          onMouseEnter={() => setHoveredIndex(4)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={Lecture} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Lecture Back Ups</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(5)}
          onMouseEnter={() => setHoveredIndex(5)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={minor_test} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Minor tests</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(6)}
          onMouseEnter={() => setHoveredIndex(6)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={board_exams} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Board Exam Modules</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(7)}
          onMouseEnter={() => setHoveredIndex(7)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={Counselling} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Counselling</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>

        <div
          style={divStyle(8)}
          onMouseEnter={() => setHoveredIndex(8)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <img style={{ height: '60px', width: '60px' }} src={Library} alt="iit" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '24px', fontWeight: '600' }}>Library</div>
            <div style={{ fontSize: '16px' }}>For IIT JEE NEET</div>
          </div>
        </div>
      </div>


      <div style={{ padding: isXs ? '0px 70px' : '0px 30px', display: 'flex', flexDirection: 'column', gap: '12px' }}>


        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Why Choose Our Online Coaching Platform?</div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Expert Teachers:</div>
          <span style={{ fontSize: '16px' }}>Our teachers are experienced and have a proven track record of success.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Personalized Learning:</div>
          <span style={{ fontSize: '16px' }}>We offer personalized learning plans to cater to individual needs.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Flexible Scheduling:</div>
          <span style={{ fontSize: '16px' }}>Our online coaching platform is flexible and can be accessed from anywhere.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Comprehensive Study Material:</div>
          <span style={{ fontSize: '16px' }}>We provide comprehensive study material and resources to aid learning.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>One-on-One Classes:</div>
          <span style={{ fontSize: '16px' }}>Our classes are conducted on a one-on-one basis, ensuring personalized attention and guidance.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Unlimited Free Test:</div>
          <span style={{ fontSize: '16px' }}>We offer unlimited free tests to help you assess your knowledge and identify areas for improvement.</span>
        </div>
        <div style={{ fontSize: '16px', gap: '10px', display: 'flex', flexDirection: isXs ? '' : 'column' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}>Unlimited Free Study Material:</div>
          <span style={{ fontSize: '16px' }}>We provide unlimited free study material, including notes, videos, and practice questions.</span>
        </div>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
      </div>


      <div style={{ padding: isXs ? '0px 70px' : '0px 30px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Unlimited Mock Tests for Unbeatable Success</div>
        <div style={{ fontSize: '16px', marginBottom: '20px' }}>Give your child the edge they need to succeed with our unlimited mock tests. Our comprehensive testing platform provides realistic simulations of actual exams, helping your child build confidence, identify areas of improvement, and develop a winning strategy for IIT- JEE (Main & Adv),  NEET-UG,  BITSAT, Olympiads, 12th ,11th (CBSE  ICSE  IB & other state board).</div>

        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Unlimited mock tests for IIT- JEE (Main & Adv), NEET-UG, BITSAT, Olympiads, 12th, 11th (CBSE, ICSE, IB & other state board) and Foundation courses</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Realistic simulations of actual exams to build confidence and identify areas of improvement.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Comprehensive performance analysis and feedback to track progress.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Personalised recommendations for improvement and growth.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Access to expert guidance and support to help your child succeed.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Instant result declaration after each test.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Weekly doubt session classes to clarify doubts and improve understanding.</li>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />

        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>Benefits of Online Coaching for Students and Parents</div>
        <div style={{ fontSize: '16px', marginBottom: '20px' }}>Our online coaching platform offers a range of benefits for students and parents, including flexible timing, time saving, and increased parental involvement. Here are some of the key benefits of our online coaching platform.</div>
        <div style={{ fontSize: '16px', alignItems: 'center', gap: '10px' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}> 1. Flexible Timing:</div>
          <div style={{ fontSize: '16px', paddingLeft: '22px' }}>Learn from the comfort of your own home, at a time that suits you. No need to travel to coaching centres or adjust your schedule to fit in with traditional coaching classes.</div>
        </div>

        <div style={{ fontSize: '16px', alignItems: 'center', gap: '10px' }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}> 2. Time Saving:</div>
          <div style={{ fontSize: '16px', paddingLeft: '22px' }}>Save time and energy by not having to travel to coaching centres. Use this time to focus on your studies, extracurricular activities, or other interests.</div>
        </div>

        <div style={{ fontSize: '16px', alignItems: 'center', gap: '10px', }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}> 3. Increased Parental Involvement:</div>
          <div style={{ fontSize: '16px', paddingLeft: '22px' }}>With our online coaching platform, parents can keep track of their child's progress and stay involved in their education. This helps to ensure that students stay motivated and focused on their goals.</div>
        </div>

        <div style={{ fontSize: '16px', alignItems: 'center', gap: '10px', }}>
          <div style={{ fontSize: '18px', fontWeight: '500' }}> 4. Safety and Security:</div>
          <div style={{ fontSize: '16px', paddingLeft: '22px' }}>In today's environment, it's more important than ever to ensure the safety and security of our children. With our online coaching platform, students can learn from the comfort of their own home, without having to travel to coaching centers or other locations.</div>
        </div>

        <div style={{ fontSize: '16px', alignItems: 'center', gap: '10px', }}>

          <div style={{ fontSize: '18px', fontWeight: '500' }}> 5. Personalized Attention:</div>
          <div style={{ fontSize: '16px', paddingLeft: '22px' }}>Our online coaching platform provides personalized attention to each student, which helps to ensure that they receive the support and guidance they need to succeed.</div>
        </div>

        <div style={{ textAlign: 'center', fontSize: isXs ? '28px' : '24px', fontWeight: 'bold', marginBottom: isXs ? '40px' : '20px', marginTop: isXs ? '40px' : '20px' }}>How Our Online Coaching Platform Works</div>

        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Register on our website and create an account.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Choose your course and Book a demo class.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Get access to our online coaching platform and start learning.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Interact with our teachers and get your doubts cleared.</li>
        <li style={{ fontSize: '16px', paddingLeft: '20px', textIndent: '-20px' }}>Schedule your classes at a time that suits you.</li>
        <hr style={{ marginTop: '5px', marginBottom: '5px', border: '0', borderTop: '1px solid rgb(96, 94, 94)' }} />
      </div>

 
      <div style={{ 
  height: isXs ? '400px' : '600px', 
  padding: isXs ? '50px 30px' : '50px 10px', 
  backgroundColor: '#FFF7F3', 
  marginTop: '30px' 
}}>
  <ul style={{ 
    display: 'grid', 
    gridTemplateColumns: isXs ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)', 
    gap: '10px', 
    padding: '10px', 
    fontSize: isXs ? '15px' : '12px',
    justifyContent: 'center', // Centers the grid items horizontally
    listStylePosition: 'inside', // Ensures bullets (if any) are aligned properly
  }}>
<li>Online Tuition Classes for IIT-JEE</li>
    <li>IIT-JEE Main and Advanced Online Tuition</li>
    <li>NEET-UG Online Tuition</li>
    <li>Online Tuition for BITSAT Exam</li>
    <li>BITSAT Online Tuition Classes</li>
    <li>Online Tuition for Olympiads</li>
    <li>Olympiad Online Tuition Classes</li>
    <li>Online Tuition for 12th Class</li>
    <li>12th Online Tuition Classes</li>
    <li>Online Tuition for 11th Class</li>
    <li>11th Online Tuition Classes</li>
    <li>Online Tuition Classes in Nainital</li>
    <li>Best Online Tuition in Nainital</li>
    <li>Online Tuition Classes in Haridwar</li>
    <li>Best Online Tuition in Haridwar</li>
    <li>Online Tuition Classes in Ajmer</li>
    <li>Best Online Tuition in Ajmer</li>
    <li>Online Tuition Classes in Alwar</li>
    <li>Best Online Tuition in Alwar</li>
    <li>Online Tuition Classes in Indore</li>
    <li>Best Online Tuition in Indore</li>
    <li>Online Tuition Classes in Agra</li>
    <li>Best Online Tuition in Agra</li>
    <li>Online Tuition Classes in Noida</li>
    <li>Best Online Tuition in Noida</li>
    <li>Online Tuition Classes in Rishikesh</li>
    <li>Best Online Tuition in Rishikesh</li>
  </ul>
</div>

    </div>

    <Dialog
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      onClose={handleClose("backdropClick")}
      open={open}
      sx={{
        overflow: isXs ? "" : "auto",
        "& .MuiDialog-paper": {
          width: isXs ? '38%' : '600px',
          maxWidth: 'none',
        }
      }}

    >
      <div
        className="modal-content"
        style={{
          marginTop: isXs ? "" : "0%",
          textAlign: isXs ? "" : "center",
          width: isXs ? "100%" : "100%",

        }}
      >
        <Button
          style={{
            position: "absolute",
            right: "0%",
            backgroundColor: "white",
            borderRadius: "100%",
            minWidth: "2rem",
            color: "black",
          }}
          onClick={() => handleClose("close")}
        >
          X
        </Button>
        <div
          className="text-center py-2 fw-bold"
          style={{
            backgroundColor: "#CB8B65",
            width: "100%",
            fontSize: isXs ? "28px" : "22px",
            marginBottom: "5%",
            display: "flex",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          <div
            style={{
              color: "#FFDB7E",
            }}
          >
            FREE
          </div>
          <div
            style={{
              color: "white",
            }}
          >
            REGISTRATION
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <Box
            className="d-flex justify-content-center mt-2"
            component="form"
            sx={{
              "& .MuiTextField-root": {
                m: 1,
                width: isXs ? "23ch" : "75%",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderWidth: "0.5px",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <div style={{ textAlign: isXs ? "end" : "center" }}>
                  <TextField
                    {...register("fullName")}
                    name="fullName"
                    id="fullName"
                    label="Full Name"
                    type="text"
                    placeholder="Enter your Full Name"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setFullName(e.target.value)
                  // }
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginRight: isXs ? "12%" : "",
                    }}
                  >
                    {errors.fullName?.message}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <div>
                  <TextField
                    {...register("mobileNumber")}
                    name="mobileNumber"
                    id="mobileNumber"
                    label="Mobile Number"
                    type="number"
                    placeholder="Enter your Mobile Number"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setMobileNumber(e.target.value)
                  // }
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: isXs ? "5%" : "",
                    }}
                  >
                    {errors.mobileNumber?.message}
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
          <Box
            className="d-flex  mt-1 justify-content-between "
            component="form"
            sx={{
              "& .MuiTextField-root": {
                m: 1,
                width: isXs ? "23ch" : "75%",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderWidth: "0.5px",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <div style={{ textAlign: isXs ? "end" : "center" }}>
                  <TextField
                    {...register("email")}
                    name="email"
                    id="email"
                    label="Email"
                    type='"email'
                    placeholder="Enter your Email"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                    style={{ marginLeft: "3%" }}
                  // onChange={(e) =>
                  //     setEmail(e.target.value)
                  // }
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginRight: isXs ? "20%" : "",
                    }}
                  >
                    {errors.email?.message}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <FormControl
                  component="fieldset"
                  style={{ marginLeft: "4%" }}
                >
                  <FormLabel
                    component="legend"
                    style={{
                      marginBottom: "0%",
                      fontSize: isXs ? "0.9vw" : "3vw",
                      color: "black",
                      letterSpacing: "0px",
                    }}
                  >
                    Mode of Classes*
                  </FormLabel>
                  <Controller
                    // rules={{ required: true }}
                    control={control}
                    name="classMode"
                    render={({ field }) => (
                      <RadioGroup
                        row
                        aria-label="position"
                        {...field}
                        name="position"
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio color="primary" />}
                          label={
                            <span
                              style={{
                                fontSize: isXs ? "1vw" : "3vw",
                              }}
                            >
                              Online
                            </span>
                          }
                        />
                        <FormControlLabel
                          value="0"
                          control={<Radio color="primary" />}
                          label={
                            <span
                              style={{
                                fontSize: isXs ? "1vw" : "3vw",
                              }}
                            >
                              Offine
                            </span>
                          }
                        />
                      </RadioGroup>
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box
            className="d-flex justify-content-center mt-1"
            component="form"
            sx={{
              "& .MuiTextField-root": {
                m: 1,
                width: isXs ? "23ch" : "75%",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderWidth: "0.5px",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <div style={{ textAlign: isXs ? "end" : "center" }}>
                  <TextField
                    name="ccb"
                    id="ccb"
                    label="Course / Class/ Board"
                    type='"text'
                    placeholder="Enter Course You Need"
                    {...register("course")}
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setCource(e.target.value)
                  // }
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginRight: isXs ? "17%" : "",
                    }}
                  >
                    {errors.course?.message}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                <div>
                  <TextField
                    name="subject"
                    {...register("subject")}
                    id="subject"
                    label="Subject"
                    type="text"
                    placeholder="Enter Subject You Need"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setSubject(e.target.value)
                  // }
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: isXs ? "5%" : "",
                    }}
                  >
                    {errors.subject?.message}
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
          <Box
            className="d-flex justify-content-center mt-1"
            component="form"
            sx={{
              "& .MuiTextField-root": {
                m: 1,
                width: isXs ? "13.8ch" : "75%",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderWidth: isXs ? "2px" : "2px",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                <div style={{ textAlign: isXs ? "end" : "center" }}>
                  <TextField
                    {...register("city")}
                    name="city"
                    id="city"
                    label="City"
                    type='"text'
                    placeholder="Enter City Name"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setCity(e.target.value)
                  // }
                  />
                  <p style={{ fontSize: "12px", color: "red" }}>
                    {errors.city?.message}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                <div style={{ textAlign: "center" }}>
                  <TextField
                    {...register("area")}
                    name="area"
                    id="area"
                    label="Area"
                    type="text"
                    placeholder="Enter Area Name"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setArea(e.target.value)
                  // }
                  />
                  <p style={{ fontSize: "12px", color: "red" }}>
                    {errors.area?.message}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                <div tyle={{ textAlign: "start" }}>
                  <TextField
                    {...register("pincode")}
                    name="pincode"
                    id="pincode"
                    label="Pincode"
                    type="text"
                    placeholder="Enter Pincode"
                    required
                    inputProps={{
                      style: {
                        height: "10px",
                        fontSize: "12px",
                      },
                    }}
                    InputLabelProps={{
                      sx: { color: "black" },
                    }}
                    color="grey"
                    focused
                  // onChange={(e) =>
                  //     setPincode(e.target.value)
                  // }
                  />
                  <p style={{ fontSize: "12px", color: "red" }}>
                    {errors.pincode?.message}
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
          <div className="d-flex justify-content-center my-2">

            {loading ? (
              <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                <CircularProgress color="success" />
              </Stack>
            ) : (
              <button
                type="submit"
                className="btn btn-primary py-2 w-75 fw-bold"
                style={{
                  fontSize: "14px",
                  border: "1px solid #CB8B65",
                  backgroundColor: "#FFDB7E",
                  color: "#866D2C",
                  borderRadius: "0",
                }}
              >
                Next
              </button>
            )}
          </div>
        </form>
        <div
          style={{
            height: "40px",
            textAlign: "center",
            alignItems: "center",
            padding: "10px 0px",
          }}
        >
          {" "}
          <span style={{ fontWeight: "700", fontSize: "14px" }}>
            Are you a Tutor?
          </span>{" "}
          <a href="/signup-teacher">
            <span style={{ fontSize: "14px", fontWeight: "700" }}>
              Create Free Profile
            </span>
          </a>
        </div>

        <div className="d-flex flex-row justify-content-between w-full mb-3">
          <div
            className="flex-grow-1 text-center"
            style={{
              fontSize: "12px",
              fontWeight: "900",
            }}
          >
            <small className="block">
              <span className="">By signing up you agree to our </span>
              <a href="/terms-conditions" style={{ color: "#0582D2" }}>
                {" "}
                Terms and Conditions
              </a>
            </small>
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      open={openOtpNew}
      onClose={() => { }}
      maxWidth="md"
      sx={{
        "& .MuiBackdrop-root": {
          backdropFilter: "blur(1px)", // Apply blur effect directly
        },
      }}
      PaperProps={{
        sx: {
          padding: "rem",
          overflowX: "hidden",
        },
      }}
    >
      <Button
        onClick={handleCloseOtpNew}
        style={{
          position: "absolute",
          right: "0%",
          top: "0",
          backgroundColor: "white",
          borderRadius: "100%",
          minWidth: "2rem",
          color: "black",
          border: "1px solid black",
        }}
      >
        X
      </Button>

      <div style={{ padding: "1rem" }}>
        <form
          onSubmit={handleSubmitOtpNew}
          style={{ padding: isXs ? "0px 10px" : "0px 0px" }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontSize: "30px", textAlign: "center" }}>
              OTP Verification{" "}
            </div>

            <div style={{ textAlign: "center" }}>
              {" "}
              A One-Time Password has been sent to{" "}
              {studentQueryFormData
                ? studentQueryFormData.get("mobile")
                : null}
            </div>
            <div>
              <MuiOtpInput
                style={{
                  width: isXs ? "400px" : "270px",
                  gap: isXs ? "20px" : "5px",
                  padding: "14px 3px",
                  alignItems: "center",
                  textAlign: "center",
                  display: "flex",
                  margin: "0px auto",
                }}
                value={otpNew}
                onChange={handleChangeOtpNew}
                length={6}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
                gap: "10px",
                flexDirection: isXs ? "" : "column",
              }}
            >
              <div style={{ textAlign: "center" }}>Didn’t Receive OTP?</div>
              {loading2 ? (
                <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                  <CircularProgress color="success" />
                </Stack>
              ) : (
                <div
                  type="button"
                  style={{ color: "#cb8b65", textAlign: "center" }}
                  onClick={handleResendOtpNew}
                >
                  Resend OTP
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "70px",
            }}
          >
            {loading ? (
              <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                <CircularProgress color="success" />
              </Stack>
            ) : (
              <button
                style={{
                  backgroundColor: "#CB8B65",
                  color: "white",
                  width: "30rem",
                  height: "2.5rem",
                  border: "none",
                  borderRadius: "3px",
                }}
              >
                Submit
              </button>
            )}
          </div>
        </form>
      </div>
    </Dialog>

    <Footer />
  </>
  )
}

export default OnlineCoaching